import { SlidersOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, Tooltip } from 'antd';
import { useTheme } from '../../providers/theme';
import { useState } from 'react';
import { getColors } from '../utils/getColors';

interface ColorSettingsProps {
  chartColors: {
    scatter: string;
    line: string;
  };
  setChartColors: (colors: { scatter: string; line: string }) => void;
}

const ColorSettings = (props: ColorSettingsProps) => {
  const { isDay } = useTheme();
  const colors = getColors(isDay);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const onFinish = () => {
    const scatterColor = form.getFieldValue('scatter-color');
    const lineColor = form.getFieldValue('line-color');
    props.setChartColors({
      scatter: scatterColor || props.chartColors.scatter,
      line: lineColor || props.chartColors.line
    });
    setIsModalOpen(false);
  };

  return (
    <>
      <Tooltip title="Chart Settings">
        <Button
          type="default"
          style={{ color: colors.text, marginRight: '0.5rem' }}
          icon={<SlidersOutlined />}
          onClick={() => setIsModalOpen(true)}
          data-testid="chart-settings-correlation"
        ></Button>
      </Tooltip>

      <Modal
        title="Chart Settings"
        open={isModalOpen}
        okText="Edit colors"
        onCancel={() => setIsModalOpen(false)}
        onOk={form.submit}
      >
        <Form
          form={form}
          onFinish={onFinish}
          initialValues={{
            'scatter-color': props.chartColors.scatter,
            'line-color': props.chartColors.line
          }}
        >
          <div style={{ marginTop: '1.5rem' }}>
            <h6>Scatter color</h6>
            <Form.Item name="scatter-color">
              <Input
                type="color"
                name="scatter-color"
                style={{ width: '100%' }}
                defaultValue={props.chartColors.scatter}
              />
            </Form.Item>
          </div>
          <div style={{ marginTop: '1.5rem' }}>
            <h6>Line color</h6>
            <Form.Item name="line-color">
              <Input
                type="color"
                name="line-color"
                style={{ width: '100%' }}
                defaultValue={props.chartColors.line}
              />
            </Form.Item>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default ColorSettings;
